/**
 * @generated SignedSource<<af3dd0affaf5bd58d016ce04247d87f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LANGUAGE = "ENGLISH_US" | "ENGLISH_UK" | "ENGLISH_EU" | "SPANISH" | "DANISH" | "POLISH" | "FRENCH" | "%future added value";
export type UpdateViewerInput = {
  email?: string | null;
  jobTitle?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  initials?: string | null;
  userType?: string | null;
  roleId?: string | null;
  profileId?: string | null;
  departmentId?: string | null;
  holidayCalendarId?: string | null;
  language?: LANGUAGE | null;
  oldPassword?: string | null;
  newPassword?: string | null;
  labels?: ReadonlyArray<string | null> | null;
  profilePictureId?: string | null;
  notificationFrequency?: number | null;
  notifyOnProjectStatusChange?: boolean | null;
  notifyOnPersonJoin?: boolean | null;
  notifyOnAssignedProject?: boolean | null;
  notifyOnProjectDeadline?: boolean | null;
  notifyOnAssignedTask?: boolean | null;
  notifyOnAssignedTaskUpdate?: boolean | null;
  notifyOnTaskDeadline?: boolean | null;
  notifyOnMention?: boolean | null;
  notifyOnInvoiceDueDate?: boolean | null;
  notifyOnInvoiceOverdue?: boolean | null;
  notifyOnInvoiceDaysOverdue?: boolean | null;
  notifyOnInvoiceCreatedOrDeleted?: boolean | null;
  notifyOnInvoiceStatusChange?: boolean | null;
  notifyOnInvoiceDateReached?: boolean | null;
  notifyOnInvoicePayment?: boolean | null;
  notifyOnInvoiceDateChanged?: boolean | null;
  notifyOnInvoiceDueDateChanged?: boolean | null;
  notifyOnTaskDescriptionChange?: boolean | null;
  notifyOnTaskTitleChange?: boolean | null;
  notifyOnTaskEstimateChange?: boolean | null;
  notifyOnTaskStartDateChange?: boolean | null;
  notifyOnTaskEndDateChange?: boolean | null;
  notifyOnTaskSprintChange?: boolean | null;
  notifyOnTaskPhaseChange?: boolean | null;
  notifyOnTaskStatusColumnChange?: boolean | null;
  notifyOnTaskProjectChange?: boolean | null;
  notifyOnTaskSubtaskChange?: boolean | null;
  notifyOnTaskSubtaskEstimateChange?: boolean | null;
  notifyOnTaskCommentChange?: boolean | null;
  notifyOnTaskFileChange?: boolean | null;
  notifyOnTaskBugChange?: boolean | null;
  notifyOnTaskBlockedChange?: boolean | null;
  notifyOnTaskRepeatingChange?: boolean | null;
  notifyOnTimeOffManager?: boolean | null;
  notifyOnTimeOffOwner?: boolean | null;
  projectDeadlineNotificationPeriod?: number | null;
  taskDeadlineNotificationPeriod?: number | null;
  invoiceNotificationDaysOverdue?: number | null;
  disableNotifications?: boolean | null;
  notifyInAppOnPersonJoin?: boolean | null;
  notifyInAppOnProjectStatusChange?: boolean | null;
  notifyInAppOnAssignedProject?: boolean | null;
  notifyInAppOnProjectDeadline?: boolean | null;
  notifyInAppOnAssignedTask?: boolean | null;
  notifyInAppOnAssignedTaskUpdate?: boolean | null;
  notifyInAppOnTaskDeadline?: boolean | null;
  notifyInAppOnMention?: boolean | null;
  notifyInAppOnInvoiceDueDate?: boolean | null;
  notifyInAppOnInvoiceOverdue?: boolean | null;
  notifyInAppOnInvoiceDaysOverdue?: boolean | null;
  notifyInAppOnInvoiceCreatedOrDeleted?: boolean | null;
  notifyInAppOnInvoiceStatusChange?: boolean | null;
  notifyInAppOnInvoiceDateReached?: boolean | null;
  notifyInAppOnInvoicePayment?: boolean | null;
  notifyInAppOnInvoiceDateChanged?: boolean | null;
  notifyInAppOnInvoiceDueDateChanged?: boolean | null;
  notifyInAppOnTaskDescriptionChange?: boolean | null;
  notifyInAppOnTaskTitleChange?: boolean | null;
  notifyInAppOnTaskEstimateChange?: boolean | null;
  notifyInAppOnTaskStartDateChange?: boolean | null;
  notifyInAppOnTaskEndDateChange?: boolean | null;
  notifyInAppOnTaskSprintChange?: boolean | null;
  notifyInAppOnTaskPhaseChange?: boolean | null;
  notifyInAppOnTaskStatusColumnChange?: boolean | null;
  notifyInAppOnTaskProjectChange?: boolean | null;
  notifyInAppOnTaskSubtaskChange?: boolean | null;
  notifyInAppOnTaskSubtaskEstimateChange?: boolean | null;
  notifyInAppOnTaskCommentChange?: boolean | null;
  notifyInAppOnTaskFileChange?: boolean | null;
  notifyInAppOnTaskBugChange?: boolean | null;
  notifyInAppOnTaskBlockedChange?: boolean | null;
  notifyInAppOnTaskRepeatingChange?: boolean | null;
  notifyInAppOnTimeOffManager?: boolean | null;
  notifyInAppOnTimeOffOwner?: boolean | null;
  lastSeenInAppNotification?: number | null;
  disableInAppNotifications?: boolean | null;
  disableCelebrationAnimations?: boolean | null;
  projectDeadlineInAppNotificationPeriod?: number | null;
  taskDeadlineInAppNotificationPeriod?: number | null;
  sendNewsletter?: boolean | null;
  monday?: number | null;
  tuesday?: number | null;
  wednesday?: number | null;
  thursday?: number | null;
  friday?: number | null;
  saturday?: number | null;
  sunday?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  timerStartDate?: string | null;
  timerEndDate?: string | null;
  timerTaskId?: string | null;
  cost?: number | null;
  flowSampleStep?: string | null;
  timeLogPersonId?: string | null;
  githubPersonId?: string | null;
  gitlabPersonId?: string | null;
  gitlabServerPersonId?: string | null;
  jiraCloudId?: string | null;
  jiraServerId?: string | null;
  unit4PersonId?: string | null;
  sageIntacctId?: string | null;
  sageIntacctName?: string | null;
  sageIntacctEmail?: string | null;
  sageIntacctLocationId?: string | null;
  adoUserId?: string | null;
  onboardingInitialStep?: string | null;
  onboardingProjectPhasesStep?: string | null;
  onboardingProjectBudgetStep?: string | null;
  onboardingProjectBoardStep?: string | null;
  onboardingProjectOverviewStep?: string | null;
  onboardingTaskModalStep?: string | null;
  onboardingOverviewTimeStep?: string | null;
  setToRunningNotificationLastDismissalDate?: string | null;
  useNewUIWorkflow?: boolean | null;
  savedFiltersJson?: string | null;
  adminPassword?: string | null;
  calendarViewPrivateEvents?: boolean | null;
  hiBobId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updatePasswordMutation$variables = {
  input: UpdateViewerInput;
};
export type updatePasswordMutation$data = {
  readonly updateViewer: {
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type updatePasswordMutation = {
  variables: updatePasswordMutation$variables;
  response: updatePasswordMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateViewerPayload",
    "kind": "LinkedField",
    "name": "updateViewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "462eea16b83059e826a5641db491dcb9",
    "id": null,
    "metadata": {},
    "name": "updatePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation updatePasswordMutation(\n  $input: UpdateViewerInput!\n) {\n  updateViewer(input: $input) {\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "bac4a7651074e6e41a60059cdf1c884c";

export default node;
